
                export default function (Component) {
                    Component.__source = "library/layouts/VabLayoutColumn/index.vue"
                }
            